import React, { useRef } from 'react';
import './Header.css';
import Logo from '../../../assets/images/Logo.png';
import { Link, NavLink } from 'react-router-dom';

function Header() {
  const offcanvasRef = useRef(null);

  const closeSidebar = () => {
    if (offcanvasRef.current) {
      offcanvasRef.current.querySelector('.btn-close').click();
    }
  };

  return (
    <>
      <div className='TopHeaderSection'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4 col-sm-4 col-xs-12'></div>
            <div className='col-md-8 col-sm-8 col-xs-12'>
              <div className='LoginBtnBox'>
                <Link to='https://vendor.oidcltd.com/' target='_blank' className='LoginBtn'>Login As Customer</Link>
                <Link to='#' className='LoginBtn LoginBtnDepartment'>Login As Department</Link>
              </div>
            </div>
          </div>

        </div>
      </div>

      <header className='HeaderSection'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-2 col-sm-2 col-xs-12'>
              <Link to='/'><img className='Logoimg' src={Logo} alt="OIDC Logo" /></Link>
            </div>
            <div className='col-md-10 col-sm-10 col-xs-12'>
              <div className='HeaderNavigationBox'>

                <nav className="navbar navbar-expand-lg">

                  <ul className="navbar-nav webNavBar">
                    <li className="nav-item">
                      <NavLink
                        to='/'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/aboutus'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        About us
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/privacy'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Privacy & Policy
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/terms'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Terms & Conditions
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/refund'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Refund & Cancellations Policy
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/contactus'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Contact Us
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to='/delivery'
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}

                      >
                        Delivery & Shipping Policy
                      </NavLink>
                    </li>
                  </ul>
                  <div className="MobileSideBar">
                  <i data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" className="fas fa-stream"></i>
                  <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                  <div className="offcanvas-header">
                   <img className='Logoimg' src={Logo} alt="OIDC Logo" />
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button></div><div className="offcanvas-body"><nav className="navbar navbar-expand-lg"><div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav"><li className="nav-item">
                  <a className="nav-link active" href="/" aria-current="page">Home</a>
                  </li><li className="nav-item"><a className="nav-link " href="/aboutus">About us</a></li><li className="nav-item"><a className="nav-link " href="/privacy">Privacy &amp; Policy</a></li><li className="nav-item"><a className="nav-link " href="/terms">Terms &amp; Conditions</a></li><li className="nav-item"><a className="nav-link " href="/refund">Refund &amp; Cancellations Policy</a></li><li className="nav-item"><a className="nav-link " href="/contactus">Contact Us</a></li><li className="nav-item"><a className="nav-link " href="/delivery">Delivery &amp; Shipping Policy</a></li></ul></div></nav></div></div></div>
                </nav>

                {/* <i data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" className="fas fa-stream"></i> */}

                {/* <div
                  className="offcanvas offcanvas-end"
                  tabIndex="-1"
                  id="offcanvasRight"
                  aria-labelledby="offcanvasRightLabel"
                  ref={offcanvasRef}
                >
                   <div className="offcanvas-header">
                    <img className='Logoimg' src={Logo} alt="OIDC Logo" />
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  </div> 
                  <div className="offcanvas-body">
                  
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>

  );
}

export default Header;
